import request from '..'

export interface TenantConfig {
  id: string
  name: string
  slug: string
  settings: Record<string, any>
}

export interface Tenant {
  id: string
  name: string
  slug: string
}

const getTenantConfig = async (): Promise<TenantConfig> => {
  const res = await request.get<DetailResponse<TenantConfig>>('/v1/tenants/config')
  return res.data.data
}

const getTenants = async (): Promise<Tenant[]> => {
  const res = await request.get<ListResponse<Tenant>>('/v1/tenants')
  return res.data.data
}

export const TenantApi = {
  getTenantConfig,
  getTenants,
}
